
import { Observer } from 'mobx-vue'
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import ArticleShareLCard from './card/articleShareLCard.vue'
import ArticleShareRCard from './card/articleShareRCard.vue'

@Observer
@Component({
  components: {
    LazyImg,
    ArticleShareLCard,
    ArticleShareRCard
  }
})
export default class extends Vue {
  get dataSource() {
    return this.$store.$homeV2.ArticleSharing
  }

  handleClick(url: string) {
    window.open(url)
  }

  handleClickMore() {
    window.open('/about?active=1')
  }

  created(): void {
    this.$store.$homeV2.ArticleSharing.loadArticleSharing()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
